import React from 'react'
import { ProgressBar } from 'ui'
import { useValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import PropTypes from 'prop-types'

export function ChecklistProgress (props) {

  const {
    progressName = 'fill_percentage',
  } = props

  const fillPercentage = useValue(progressName)

  const progress = [
    { color: 'bg-primary-500', progress: fillPercentage }
  ]

  return (
    <div>
      <Displays.Text name='filled_fields_count'/>/<Displays.Text name='fields_count'/>
      <ProgressBar progress={progress}/>
    </div>
  )
}

ChecklistProgress.propTypes = {
  progressName: PropTypes.string,
}

export default ChecklistProgress
